export type RoleType = {
  id: string;
  name: string;
  permissions: string[];
};

export enum WholePermissions {
  //Global permissions
  VIEW_ADMIN_PANEL = "VIEW_ADMIN_PANEL",

  //User's permissions
  GET_USERS = "GET_USERS",
  CREATE_USER = "CREATE_USER",
  VIEW_USER = "VIEW_USER",
  EDIT_USER = "EDIT_USER",
  DELETE_USER = "DELETE_USER",

  //Roles's permissions
  GET_PERMISSIONS = "GET_PERMISSIONS",
  GET_ROLES = "GET_ROLES",
  CREATE_ROLE = "CREATE_ROLE",
  VIEW_ROLE = "VIEW_ROLE",
  EDIT_ROLE = "EDIT_ROLE",
  DELETE_ROLE = "DELETE_ROLE",

  //Projects's permissions
  GET_PROJECTS = "GET_PROJECTS",
  CREATE_PROJECT = "CREATE_PROJECT",
  VIEW_PROJECT = "VIEW_PROJECT",
  EDIT_PROJECT = "EDIT_PROJECT",
  DELETE_PROJECT = "DELETE_PROJECT",

  //Designs's permissions
  GET_DESIGNS = "GET_DESIGNS",
  CREATE_DESIGN = "CREATE_DESIGN",
  VIEW_DESIGN = "VIEW_DESIGN",
  EDIT_DESIGN = "EDIT_DESIGN",
  DELETE_DESIGN = "DELETE_DESIGN",

  //File's permissions
  DELETE_FILES = "DELETE_FILES",

  //Product' permissions
  ADD_HOME_SLIDER = "ADD_HOME_SLIDER",
  GET_HOME_SLIDER = "GET_HOME_SLIDER",
  VIEW_HOME_SLIDER = "VIEW_HOME_SLIDER",
  EDIT_HOME_SLIDER = "EDIT_HOME_SLIDER",
  DELETE_HOME_SLIDER = "DELETE_HOME_SLIDER",

  //Settings' permission
  ADD_SETTINGS = "ADD_SETTINGS",
  GET_SETTINGS = "GET_SETTINGS",
  VIEW_SETTINGS = "VIEW_SETTINGS",
  EDIT_SETTINGS = "EDIT_SETTINGS",
  DELETE_SETTNGS = "DELETE_SETTNGS",
}
